<template>
  <div class="box-container ma-0 pa-0" style="width: 100%">
    <div class="row-header ma-0 pa-3" align="center" :justify="isOnMobile ? 'center' : 'space-around'" v-if="showSortSearch">
      <v-row class="ma-0 pa-0" align="center">
        <t-button v-if="TR.Locale != Translation.bg.Locale" :class="'ma-1'" :btnDisabled="isWaitingRefresh" :btnText="isOnMobile ? '' : TR.Refresh" :btnIcon="'mdi-cloud-sync-outline'" @click.native="refreshClickRO()" />
        <v-select v-model="sortType" @change="sort" class="ma-2 mt-3 pa-0" :style="isOnMobile ? 'max-width: 130px;' : 'max-width: 250px;'" hide-details :items="isOnMobile ? sortListMobile : sortList" :label="TR.Sort" dense />
        <!-- <v-tooltip v-if="TR.Locale == Translation.bg.Locale" top :disabled="hideTooltips">
          <template v-slot:activator="{ on }"> -->
        <v-chip class="ma-1" :color="this.zRepFilter.vals[0] != null ? Colors.IconColor : ''" :filter-icon="'mdi-check'" outlined @click="doFilter()">
          {{ getFilterText() }}
        </v-chip>
        <!-- {{ TR.ZReportReceived }}
          </template>
        </v-tooltip> -->
        <t-filter-button :datatype="datatype" :class="'ma-1 mt-0'" @click.native="isFilterMenuVisible = !isFilterMenuVisible" />
      </v-row>
      <v-row v-if="isFilterMenuVisible" class="ma-0 pa-0">
        <v-card class="ma-1 pa-2">
          <t-filters :datatype="datatype" />
        </v-card>
      </v-row>
    </div>
    <div class="row-content elevation-0" ref="refVirtualScrollerContainer" v-resize:debounce="recalcWidthHeight" :style="isInDarkMode ? 'background: #050505' : ''">
      <v-virtual-scroll ref="refVirtualScroll" :height="virtualScrollerHeight" :item-height="deviceHeight" :items="getDevices2d" :width="virtualScrollerWidth">
        <template v-slot="{ item }">
          <v-row justify="center" class="ma-0 pa-0" align="center">
            <v-card v-for="(dev, index) in item" class="custom_hover_shadow ma-1 pa-0 pl-3" elevation="3" :key="index" :width="deviceWidth" :height="deviceHeight - 8" max-height="250px">
              <v-row class="ma-0 pa-0" justify="center" align="center">
                <v-col cols="2">
                  <v-tooltip top :disabled="hideTooltips">
                    <template v-slot:activator="{ on }">
                      <v-row v-on="on" justify="center" align="center">
                        <v-badge avatar overlap left color="transparent">
                          <template v-slot:badge>
                            <v-avatar>
                              <v-icon small :color="dev.Status.Color">{{ dev.Status.Icon }}</v-icon>
                            </v-avatar>
                          </template>
                          <v-avatar size="44" tile>
                            <v-img :src="dev.Image" width="auto" height="auto" contain></v-img>
                          </v-avatar>
                          <v-icon v-on="on" v-if="dev.sim && dev.sim.activatedMo == false" style="position: absolute; bottom: -6px; right: -6px" small color="error">mdi-sim-off</v-icon>
                        </v-badge>
                      </v-row>
                    </template>
                    <v-row align="center" class="ma-0 pa-0">
                      <span class="ma-0 pa-0">
                        {{ TR.Status + ":" }}
                        <span class="subtitle-2" :style="`color: ${dev.Status.Color}`">{{ dev.Status.Text }}</span>
                      </span>
                    </v-row>
                    <template v-if="dev.lastTalkDate">
                      <v-row class="ma-0 pa-0" v-if="dev.sim && dev.sim.activatedMo == false">
                        <span>{{ TR.DevWithStoppedSim }}</span>
                      </v-row>
                      <v-row class="ma-0 pa-0 mt-2">
                        <span>{{ TR.LastActivity + ": " }}</span>
                      </v-row>
                      <v-row class="ma-0 pa-0">
                        <span>{{ dev.lastTalkDate.toTremolFpString() }}</span>
                      </v-row>
                    </template>
                  </v-tooltip>
                </v-col>
                <v-col cols="10" class="ma-0 py-1">
                  <v-row style="cursor: pointer" class="ma-0 pa-0" justify="space-between" @click="goToDevInfo(dev.sn)">
                    <v-tooltip :disabled="hideTooltips" top>
                      <template v-slot:activator="{ on }">
                        <v-card-title v-on="on" class="subtitle-2 ma-0 pa-0">
                          <v-btn outlined tile small class="ma-0 pa-0" :color="isInDarkMode ? 'white' : 'black'" style="pointer-events: none; font-size: 14px; cursor: not-allowed; border: none">{{
                            dev.Name.length > 20 ? dev.Name.substring(0, 20) + "..." : dev.Name
                          }}</v-btn>
                        </v-card-title>
                      </template>
                      <v-row align="center" class="ma-0 pa-0">
                        <span>{{ dev.Name }}</span>
                      </v-row>
                      <v-row align="center" class="ma-0 pa-0">
                        <span>{{ dev.sn }}</span>
                      </v-row>
                      <v-row align="center" class="ma-0 pa-0">
                        <span>{{ dev.Address }}</span>
                      </v-row>
                    </v-tooltip>
                  </v-row>
                  <v-row class="ma-0 pa-0 mb-1" justify="start">
                    <template v-if="dev.LastReceipt && !functionRecalcTimeout">
                      <v-row class="ma-0 pa-0" justify="space-between">
                        <v-card-subtitle class="ma-0 pa-0">
                          {{ dev.LastReceipt.date.toTremolFpString() }}
                        </v-card-subtitle>
                        <v-card-subtitle class="ma-0 pa-0 text-end">
                          <v-tooltip v-if="dev.LastReceipt && dev.LastReceipt.IsNew && !dev.IsBlocked" :disabled="hideTooltips" top>
                            <template v-slot:activator="{ on }">
                              <v-scroll-y-reverse-transition>
                                <v-chip @click.stop="showLastReceipt(dev)" v-if="dev.LastReceipt && dev.LastReceipt.IsNew" small v-on="on" class="white--text ma-0 mt-n1 pa-1" color="success">
                                  <v-icon x-small>{{ 0 > dev.LastReceipt.Sum ? "mdi-arrow-down-thick" : "mdi-arrow-up-thick" }}0</v-icon>
                                  {{ dev.LastReceipt.Sum.toFixed(2) + " " + TR.MoneyAbbreviation }}
                                </v-chip>
                              </v-scroll-y-reverse-transition>
                            </template>
                            <span>{{ TR.NewSale + ": " + dev.LastReceipt.Sum.toFixed(2) + " " + TR.MoneyAbbreviation + " " + dev.LastReceipt.date.toTremolFpString() }}</span>
                          </v-tooltip>
                          <v-tooltip v-else top>
                            <template v-slot:activator="{ on }">
                              <v-icon class="mt-n1 pa-0" @click.stop="showLastReceipt(dev)" v-on="on">mdi-file-hidden</v-icon>
                            </template>
                            <span>{{ TR.ShowLastReceipt }}</span>
                          </v-tooltip>
                        </v-card-subtitle>
                      </v-row>
                    </template>
                  </v-row>
                  <v-divider></v-divider>
                  <v-tooltip v-if="TR.Locale != 'bg' || (dev.duprofile && dev.duprofile.cosmosableDevice)" :disabled="hideTooltips" top>
                    <template v-slot:activator="{ on }">
                      <v-row v-on="on" class="ma-0 pa-0" justify="start" style="cursor: pointer" @click="goToDevSales(dev.sn)">
                        <v-row class="ma-0 pa-0" justify="space-between">
                          <v-card-subtitle class="ma-0 pa-0">{{ TR.ForTheDay + ":" }}</v-card-subtitle>
                          <v-card-subtitle class="ma-0 pa-0 text-end">{{ dev.DailyTurnover.toFixed(2) + " " + TR.MoneyAbbreviation }}</v-card-subtitle>
                        </v-row>
                        <v-row class="ma-0" justify="space-between" v-if="!hasEuroChange">
                          <v-card-subtitle class="ma-0 pa-0">{{ TR.ForTheWeek + ":" }}</v-card-subtitle>
                          <v-card-subtitle class="ma-0 pa-0 text-end">{{ dev.WeeklyTurnover.toFixed(2) + " " + TR.MoneyAbbreviation }}</v-card-subtitle>
                        </v-row>
                      </v-row>
                    </template>
                    <v-row align="center" class="ma-0 pa-0">
                      <span>{{ TR.ReportReceipts }}</span>
                    </v-row>
                  </v-tooltip>
                  <v-row v-else class="ma-0 pa-0" justify="start">
                    <v-row class="ma-0 pa-0" justify="space-between">
                      <v-card-subtitle class="ma-0 pa-0 error--text">{{ TR.DevsWithoutSaleReports }}</v-card-subtitle>
                    </v-row>
                  </v-row>
                </v-col>
              </v-row>
            </v-card>
          </v-row>
        </template>
      </v-virtual-scroll>
    </div>
    <v-row class="row-header ma-0 pa-0 elevation-2" v-if="showLegend" justify="start" align="end">
      <v-tabs class="ma-0 pa-0" :slider-color="Colors.IconColor" show-arrows dense hide-slider background-color="transparent">
        <v-tab class="ma-0 pa-0" v-for="(status, iindex) in legendItems" :key="iindex">
          <v-tooltip top :disabled="!userSettings.showTooltips || isOnAndroid">
            <template v-slot:activator="{ on }">
              <v-card flat outlined v-on="on" class="ma-1 pa-1" :style="'cursor: pointer;'" height="32px" align="center" justify="center" @click="filterDevsByStatus(status)">
                <v-icon left small :color="status.Color">{{ status.Icon }}</v-icon>
                <span style="font-size: 12px">{{ status.Text + " (" + getDevicesCountByStatus(status) + ")" }}</span>
              </v-card>
            </template>
            <span>{{ status.Description }}</span>
          </v-tooltip>
        </v-tab>
      </v-tabs>
    </v-row>
  </div>
</template>

<script>
import bus, { TR } from "../../main";
import DataManager, { DevStatus, DataFilter, DataFilterType, DataPropType } from "../../js/DataManager";
import Translation from "../../js/Translation";

export default {
  props: {
    showSortSearch: {
      type: Boolean,
      default: true,
    },
    showLegend: {
      type: Boolean,
      default: true,
    },
    showZeroTurnovers: {
      type: Boolean,
      default: true,
    },
    hasEuroChange: {
      type: Boolean,
      default: false,
    },
    showOldDevices: Boolean,
    showBlockedOnly: Boolean,
    datatype: null,
  },
  data() {
    return {
      TR: TR,
      Translation: Translation,
      isWaitingRefresh: true,
      isFilterMenuVisible: false,
      virtualScrollerOffset: 0,
      deviceHeight: 114,
      deviceWidth: 280,
      buttonsPerRow: 1,
      headerButtonsHeight: 70,
      legendHeight: 50,
      virtualScrollerHeight: 500,
      virtualScrollerWidth: "100vw",
      intervalRecalcSize: null,
      devices: [],
      searchText: "",
      deviceTurnovers: [],
      dailyAscending: true,
      weeklyAscending: true,
      sortType: TR.Device_Name,
      sortList: [
        TR.DeviceList_NameAsc,
        TR.DeviceList_NameDesc,
        TR.DeviceList_SnAsc,
        TR.DeviceList_SnDesc,
        TR.DeviceInformation_DailyTurnoverAsc,
        TR.DeviceInformation_DailyTurnoverDesc,
        TR.DeviceInformation_WeeklyTurnoverAsc,
        TR.DeviceInformation_WeeklyTurnoverDesc,
      ],
      sortListMobile: [
        TR.DeviceList_NameAsc_mobile,
        TR.DeviceList_NameDesc_mobile,
        TR.DeviceList_SnAsc_mobile,
        TR.DeviceList_SnDesc_mobile,
        TR.DeviceInformation_DailyTurnoverAsc_mobile,
        TR.DeviceInformation_DailyTurnoverDesc_mobile,
        TR.DeviceInformation_WeeklyTurnoverAsc_mobile,
        TR.DeviceInformation_WeeklyTurnoverDesc_mobile,
      ],
      functionRecalcTimeout: null,
      zRepFilter: new DataFilter("ZReportReceived", TR.ZReportReceived, DataFilterType.Equals, DataPropType.BOOL, []),
    };
  },
  computed: {
    legendItems() {
      if (this.userSettings.hideOldModels) {
        return Object.values(DevStatus).filter((v) => v != DevStatus.OldDevice);
      } else {
        return Object.values(DevStatus);
      }
    },
    getDevicesFiltered() {
      return this.devices.filter((d) => this.showOldDevices || d.duprofile.cosmosableDevice);
    },
    /** @return { Array } */
    getDevices2d() {
      var devs = this.getDevicesFiltered;
      if (this.showBlockedOnly) {
        devs = devs.filter((d) => d.IsBlocked);
      }
      var arrayLength = devs.length;
      if (arrayLength == 0) {
        return [[]];
      }
      var tempArray = [];
      for (var index = 0; index < arrayLength; index += this.buttonsPerRow) {
        var end = arrayLength <= this.buttonsPerRow + index ? arrayLength : index + this.buttonsPerRow;
        var myChunk = devs.slice(index, end);
        // Do something if you want with the group
        tempArray.push(myChunk);
      }
      return tempArray;
    },
  },
  methods: {
    getDevicesCountByStatus(status) {
      return DataManager.getData(DataManager.DataType.devices, true).filter((d) => d.Status.Text == status.Text).length;
    },
    recalcWidthHeight() {
      if (this.intervalRecalcSize) clearTimeout(this.intervalRecalcSize);
      this.intervalRecalcSize = setTimeout(() => {
        if (this.$refs.refVirtualScrollerContainer) {
          if (this.virtualScrollerHeight != this.$refs.refVirtualScrollerContainer.clientHeight - 1) {
            this.virtualScrollerHeight = this.$refs.refVirtualScrollerContainer.clientHeight - 1;
            this.virtualScrollerWidth = this.$refs.refVirtualScrollerContainer.clientWidth;
          }
        }
        // this.virtualScrollerWidth = window.innerWidth - this.$vuetify.application.left - this.$vuetify.application.right;
        // this.virtualScrollerWidth++;
        // this.virtualScrollerWidth--;
        var bpr = Math.trunc((this.virtualScrollerWidth - 20) / (this.deviceWidth + 10));
        if (bpr < 1) bpr = 1;
        this.buttonsPerRow = bpr;
      }, 333);
    },
    showLastReceipt(dev) {
      // console.log(dev)
      if (dev.LastReceipt) {
        // console.log(dev.LastReceipt);
        this.dialog.show("receipt-view", dev.LastReceipt);
      }
    },
    filterDevsClear() {
      DataManager.setFilters(this.datatype, []);
    },
    filterDevsByStatus(status) {
      var stFilter = DataManager.getFilters(this.datatype.id).find((f) => f.propname == "Status.Text");
      if (stFilter && stFilter.vals && stFilter.vals.length > 0 && stFilter.vals[0] == status.Text) {
        DataManager.removeFilter(this.datatype, stFilter);
      } else {
        // var st = new DataFilter("Status.Text", TR.Status, DataFilterType.In, DataPropType.String, [status.Text]);
        // DataManager.setFilters(this.datatype, [st, ...DataManager.getFilters(this.datatype.id)]);
        // DataManager.setFilters(this.datatype, [new DataFilter("Status.Text", TR.Status, DataFilterType.In, DataPropType.String, [status.Text])]);
        DataManager.appendFilter(this.datatype, new DataFilter("Status.Text", TR.Status, DataFilterType.In, DataPropType.String, [status.Text]));
      }
    },
    goToDevInfo(serialNum) {
      if (this.$router.getRoutes().find((r) => r.path == "/" + TR.Locale + "/devices")) {
        this.$router
          .push({ path: "/" + TR.Locale + "/devices" })
          .catch(() => {})
          .then(() => {
            this.$nextTick(() => {
              bus.$emit(bus.EVENT_DeviceDiv_ExpandInfoBySerialNumber, serialNum);
            });
          });
      } else {
        this.goToDevSales(serialNum);
      }
    },
    goToDevSales(serialNum) {
      var dev = this.devices.find((d) => d.sn == serialNum);
      DataManager.DataType.sales_reports.selectedDevs = [dev];
      var start = new Date().getDateWithoutTime();
      var end = new Date().getDateWithoutTime().addDays(1).addMilliseconds(-1);
      DataManager.DataType.sales_reports.datesFromTo = [start, end];
      var filter = new DataFilter("sn", TR.SN, DataFilterType.In, DataPropType.String, [dev.sn]);
      DataManager.setFilters(DataManager.DataType.sales_reports, [filter]);
      this.$router
        .push({ path: "/" + TR.Locale + "/gridSales" })
        .catch(() => {})
        .then(() => {
          this.$nextTick(() => {
            bus.$emit(bus.EVENT_DataManager_FILTERS_CHANGED, DataManager.DataType.sales_reports);
          });
        });
    },
    sort() {
      var sl = this.isOnMobile ? this.sortListMobile : this.sortList;
      let type = this.sortType;
      this.devices.sort(function (a, b) {
        if (type == sl[0]) return a.Name < b.Name ? -1 : a.Name > b.Name ? 1 : 0;
        else if (type == sl[1]) return a.Name > b.Name ? -1 : a.Name < b.Name ? 1 : 0;
        else if (type == sl[2]) return a.sn < b.sn ? -1 : a.sn > b.sn ? 1 : 0;
        else if (type == sl[3]) return a.sn > b.sn ? -1 : a.sn < b.sn ? 1 : 0;
        else if (type == sl[4]) return a.DailyTurnover - b.DailyTurnover;
        else if (type == sl[5]) return b.DailyTurnover - a.DailyTurnover;
        else if (type == sl[6]) return a.WeeklyTurnover - b.WeeklyTurnover;
        else if (type == sl[7]) return b.WeeklyTurnover - a.WeeklyTurnover;
      });
    },
    // getLastMonday(d) {
    //   d = new Date(d);
    //   var day = d.getDay(),
    //     diff = d.getDate() - day + (day == 0 ? -6 : 1); // adjust when day is sunday
    //   return new Date(d.setDate(diff));
    // },
    refreshData() {
      // if (this.functionRecalcTimeout) clearTimeout(this.functionRecalcTimeout);
      // this.functionRecalcTimeout = setTimeout(() => {
      this.devices = [];
      this.$nextTick(() => {
        this.devices = DataManager.getData(DataManager.DataType.devices).filter((d) => d.IsForMe);
        this.sort();
        this.waitRefresh();
        this.$nextTick(() => {
          this.$forceUpdate();
        });
      });
      //   this.functionRecalcTimeout = null;
      // }, 333);
    },
    getFilterText() {
      if (!this.zRepFilter.vals || this.zRepFilter.vals.lenght == 0 || this.zRepFilter.vals[0] == null) return this.zRepFilter.text;
      if (this.zRepFilter.vals[0] == false) return this.zRepFilter.text + " (" + TR.No + ")";
      else if (this.zRepFilter.vals[0] == true) return this.zRepFilter.text + " (" + TR.Yes + ")";
    },
    doFilter() {
      if (!this.zRepFilter.vals || this.zRepFilter.vals.lenght == 0 || this.zRepFilter.vals[0] == null) {
        this.zRepFilter.vals[0] = false;
      } else if (this.zRepFilter.vals[0] == false) {
        this.zRepFilter.vals[0] = true;
      } else {
        this.zRepFilter.vals = [];
      }
      DataManager.appendFilter(this.datatype, this.zRepFilter);
    },
    refreshClickRO() {
      this.isWaitingRefresh = true;
      DataManager.loadData(
        DataManager.DataType.sales,
        () => {
          this.waitRefresh();
        },
        true,
        DataManager.date_downloaded_to[DataManager.DataType.sales.dataid],
        null,
        DataManager.getData(DataManager.DataType.devices)
      );
    },
    waitRefresh() {
      setTimeout(() => {
        this.isWaitingRefresh = false;
      }, 1000 * 60 * 7);
    },
    setFocus(on) {
      if (on) {
        this.$refs.refVirtualScroll.$el.scrollTop = this.virtualScrollerOffset;
        this.refreshData();
        this.waitRefresh();
      } else {
        this.virtualScrollerOffset = this.$refs.refVirtualScroll.$el.scrollTop;
      }
    },
  },
  watch: {
    // virtualScrollerOffset: function() {
    //   this.$nextTick(() => {
    //     this.$refs.refVirtualScroll.$el.scrollTop = this.virtualScrollerOffset;
    //   });
    // }
  },
  created() {
    bus.$on(bus.EVENT_DataManager_DATA_CHANGED, (datatype) => {
      if (datatype == DataManager.DataType.sales || datatype == DataManager.DataType.devices) {
        this.refreshData();
      }
    });
    bus.$on(bus.EVENT_DataManager_FILTERS_CHANGED, (datatype) => {
      if (datatype == DataManager.DataType.devices) {
        var foundZRepFilter = DataManager.getFilters(this.datatype.id).find((ff) => this.zRepFilter.propname == ff.propname);
        if (foundZRepFilter) {
          this.zRepFilter.vals = foundZRepFilter.vals;
        } else {
          this.zRepFilter.vals = [];
        }
        // var fltrz = DataManager.getFilters(this.datatype.id);
        // if (fltrz) {
        //   var fltr = fltrz.find((f) => f.propname == this.zRepFilter.propname);
        //   if (fltr) {
        //     this.zRepFilter.vals = [null];
        //     this.$nextTick(() => {
        //       this.zRepFilter.vals = fltr.vals;
        //     });
        //   }
        // }
        this.refreshData();
      }
      if (this.isOnMobile) {
        this.$nextTick(() => {
          this.isFilterMenuVisible = false;
        });
      }
    });
  },
  mounted() {
    this.recalcWidthHeight();
    window.addEventListener("resize", this.recalcWidthHeight);
    this.refreshData();
  },
  updated() {
    this.recalcWidthHeight();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.recalcWidthHeight);
  },
};
</script>

<style scoped>
.slide-fade-enter-active {
  transition: all 5s ease;
}
.v-sheet--offset {
  top: -10px;
  position: relative;
}
</style>